/**
 * Composable to safely access route parameters
 * @param param The route parameter name to retrieve
 * @returns The route parameter value or undefined if not found
 * @throws Error if called outside of a Vue component or setup function
 */
export default function useRouteParam<T extends string>(param: string): T | undefined {
  const route = useRoute()

  if (!route) {
    throw new Error('useRouteParam must be called within a Vue component or setup function')
  }

  if (Array.isArray(route.params[param])) {
    return route.params[param][0] as T
  }
  else {
    return route.params[param] as T
  }
}
